export const FEATURES = {
  useNetwork: 'USE_NETWORKING',
  foodCertification: 'FOOD_CERTIFICATION',
  ncDashboard: 'FC_ENABLE_NC_DASHBOARD',
  foodDigitalNc: 'FOOD_CERT_DIGITAL_NC',
  disallowConsultantDigitalSignature: 'DISALLOW_CONSULTANT_DIGITAL_SIGNATURE',
  enableBRCGSBooking: 'ENABLE_BRCGS_BOOKING',
  enableIfsBooking: 'ENABLE_IFS_BOOKING',
  enableSqfBooking: 'ENABLE_SQF_BOOKING',
  enableFoodCertDigitalSignature: 'FOOD_CERT_DIGITAL_SIGNATURE',
  // whether to allow new ggap order in myQima, false means use aca ggap function
  enableGgapOrderInMyQima: 'GGAP_ORDER_IN_MYQIMA',
  enableReGroupPayment: 'ENABLE_RE_GROUP_PAYMENT',
  enableQimaIq: 'ENABLE_QIMA_IQ',
  qimaSnap: 'QIMA_SNAP',
};
